var WDN = WDN || {};

if (typeof WDN.MediaTab === "undefined") {
  WDN.MediaTab = (function () {
    class MediaTab extends WDN.TabTrigger {
      constructor() {
        super();

        this.section_id = this.getAttribute("data-section-id");
        if (this.section_id) {
          this.section =
            document.querySelector("#shopify-section-" + this.section_id) ||
            document.querySelector("#" + this.section_id);

          if (this.section) {
            this.dynamicGallery = this.section.querySelector(
              ".column-item-dynamic-gallery"
            );
          }
        }

        this.cached_markup = {};
      }

      onClickCallback() {
        this.callback();
      }

      readDevice() {
        this.device = "mobile";
        this.windowWidth = window.innerWidth;
        this.mediaSize = Math.floor(this.windowWidth);

        if (this.windowWidth > 880) {
          this.device = "desktop";
          this.mediaSize = Math.floor((1405 / 2) * 1.2);
        }
      }

      handleImage() {
        this.dynamicGallery.innerHTML = "";

        if (!this.imageElem) {
          this.imageElem = new Image();
          this.imageElem.src = this.groupConfig.image_raw.replace(
            "&width=1",
            "&width=" + this.mediaSize
          );
        }

        this.dynamicGallery.style.setProperty(
          "--item-ratio",
          this.groupConfig.media_ratio
        );
        this.dynamicGallery.appendChild(this.imageElem);
      }

      handleVideo() {
        this.dynamicGallery.innerHTML = "";
        this.videoElem = document.createElement("video");
        this.dynamicGallery.style.setProperty(
          "--item-ratio",
          this.groupConfig.media_ratio
        );

        // element must be made over and over, otherwise autoplay doesnt work...?
        this.groupConfig.video_sources.forEach((item) => {
          var source = document.createElement("source");
          source.type = item.type;
          source.src = item.src;
          this.videoElem.appendChild(source);
        });

        this.videoElem.controls = true;
        this.videoElem.loop = true;
        this.videoElem.setAttribute("playsinline", "");

        if (
          this.groupConfig.video_autoplay &&
          this.groupConfig.video_autoplay === "true"
        ) {
          this.videoElem.autoplay = true;
          this.videoElem.muted = true;
          this.videoElem.setAttribute("muted", "");
          this.videoElem.controls = false;
        }

        this.dynamicGallery.appendChild(this.videoElem);
      }

      handleEmbedCode() {
        this.dynamicGallery.innerHTML = this.groupConfig.embed_code;
      }

      handleLinkOverlay() {
        if (this.groupConfig.link_overlay.length > 0) {
          var linkElement = document.createElement("a");
          linkElement.setAttribute("href", this.groupConfig.link_overlay);
          linkElement.classList.add("columnMedia-linkOverlay");
          this.dynamicGallery.appendChild(linkElement);
        }
      }

      setActiveMedia() {
        this.groupConfig = this.mediaData[this.device];
        this.dynamicGallery.classList.remove("ignore-ratio");

        // don't update media if it's already playing the correct one
        if (this.dynamicGallery.hasAttribute("data-active-media-id")) {
          if (
            this.dataset.contentId ==
            this.dynamicGallery.getAttribute("data-active-media-id")
          ) {
            return;
          }
        }

        if (this.groupConfig.type === "image") {
          this.handleImage();
        }

        if (this.groupConfig.type === "video") {
          this.handleVideo();
        }

        if (
          this.groupConfig.type === "embed_code" &&
          this.groupConfig.embed_code &&
          this.groupConfig.embed_code.length > 0
        ) {
          this.handleEmbedCode();
        }

        this.handleLinkOverlay();

        // update dynamic attributes, used for various styling + not repeat changing of media
        this.dynamicGallery.setAttribute("data-type", this.groupConfig.type);
        this.dynamicGallery.setAttribute(
          "data-active-media-id",
          this.dataset.contentId
        );
      }

      slideToTab() {
        this.parentNode.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "start",
        });
      }

      activateFirstRelatedDropdown() {
        this.addEventListener("click", () => {
          var firstDropdown = document.querySelector(
            '[data-tab-content="' + this.dataset.contentId + '"] wdn-dropdown'
          );
          if (firstDropdown) firstDropdown.setActive();
        });
      }

      handleQAMode() {
        this.mediaTabHTML =
          this.querySelector("template").content.cloneNode(true);

        this.dynamicGallery.classList.add("ignore-ratio");
        this.dynamicGallery.innerHTML = "";
        this.dynamicGallery.appendChild(this.mediaTabHTML);
      }

      connectedCallback() {
        this.init();

        this.activateFirstRelatedDropdown(); // Will foldout the first dropdown on click

        this.callback = function () {
          if (!this.isDefaultStateCall) {
            this.slideToTab();
            this.isDefaultStateCall = false;
          }

          if (this.section_id && this.dynamicGallery) {
            this.readDevice();

            if (this.querySelector("script")) {
              this.mediaData = JSON.parse(
                this.querySelector("script").innerText
              )[0];
              this.setActiveMedia();
            } else {
              if (this.querySelector("template")) {
                this.handleQAMode();
              }
            }
          }
        };

        if (this.section_id && this.dynamicGallery) {
          if (this.hasAttribute("data-active")) {
            this.isDefaultStateCall = true;
            this.callback();
          }
        }
      }
    }

    customElements.define("media-tab", MediaTab);

    return MediaTab;
  })();
}
